// Prices page component
export function WhyPage() {
  return `
<div class="min-h-screen bg-gray-50">
  <div class="hero">
    <div class="hero-content">
      <h1 class="hero-title">¿Por qué CeeCasasEspaña.com?</h1>
      <p class="hero-subtitle">Conectamos a asesores energéticos y propietarios de viviendas</p>
    </div>
  </div>

  <section class="section bg-gray-50">
    <div class="container">
      <div class="max-w-6xl mx-auto prose prose-lg">
        <div class="flex flex-col md:flex-row md:items-start md:space-x-8">

          <!-- Left column -->
          <div class="bg-white p-8 rounded-lg shadow-sm md:w-2/3">
            <h2 class="text-2xl text-blue-900 mb-4">Conectamos a asesores energéticos y propietarios</h2>
            
            <p class="mb-4">
              Necesitas un certificado energético para tu vivienda o local comercial en España. 
              Y quieres que todo sea rápido, sencillo y profesional. Esperas un servicio amable, 
              a un precio justo — ¡y precisamente por eso tantas personas eligen CeeCasasEspaña.com!
            </p>

            <p class="mb-4">
              En CeeCasasEspaña.com comparamos asesores de eficiencia energética certificados en toda España 
              y te ayudamos a encontrar el profesional que mejor se adapta a tu situación. Simplificamos lo complicado. 
              Nuestros clientes nos valoran con una media de 4,9 sobre 5 estrellas, y estamos muy orgullosos de ello — 
              nos motiva cada día a ofrecerte el mejor servicio.
            </p>

            <p class="mb-4">
              Puedes filtrar fácilmente por precio, tiempo de entrega y valoración para encontrar al asesor de certificado energético adecuado. 
              Todos los asesores registrados en nuestra plataforma están oficialmente acreditados por el 
              Ministerio para la Transición Ecológica (MITECO) y trabajan conforme a las directrices nacionales 
              de certificación energética (Real Decreto 390/2021).
            </p>

            <p class="mb-4">
              Con más de 350 asesores reconocidos repartidos por toda España, monitorizamos diariamente el progreso y la satisfacción 
              de los clientes. Así sabemos exactamente quién entrega más rápido, quién tiene las mejores valoraciones 
              y quién encaja mejor con tus necesidades.
            </p>

            <p class="mb-4">
              Gracias a nuestra red en crecimiento de asesores fiables, no solo encuentras al mejor especialista para tu 
              certificación energética, sino también calidad garantizada y total tranquilidad según las normas españolas.
            </p>
          </div>

          <!-- Right column -->
          <div class="bg-white p-8 rounded-lg shadow-sm md:w-1/3">
            <img src="/images/team/compare.webp" alt="Comparar asesores energéticos" class="mb-4 w-full h-auto rounded-md object-cover" />
            <p class="mb-4">Comienza a comparar asesores de eficiencia energética en España.</p>
            <p>
              <a href="/cadastro/" data-route="/cadastro/" 
                 class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">
                Comparar asesores
              </a>
            </p>
          </div>

        </div>
      </div>
    </div>
  </section>
</div>

  `;
}
